/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Billing } from '../../models/billing';

export interface BillingLoadProcedures$Params {
  PatientType?: string | null;
}

export function billingLoadProcedures(http: HttpClient, rootUrl: string, params?: BillingLoadProcedures$Params, context?: HttpContext): Observable<StrictHttpResponse<Billing>> {
  const rb = new RequestBuilder(rootUrl, billingLoadProcedures.PATH, 'get');
  if (params) {
    rb.query('PatientType', params.PatientType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Billing>;
    })
  );
}

billingLoadProcedures.PATH = '/billing/LoadProcedures';
